/**
 *  Prevent browser to visit link if it has a class 'empty-link' or '#empty-link'
 *
 * @returns {void}
 */
export const emptyLink = () => {
    document.addEventListener('click', (e) => {
        if (e.target.getAttribute('href') === 'empty-link' || e.target.getAttribute('href') === '#empty-link') {
            e.preventDefault();
            e.stopPropagation();
        }
        const targetA = e.target.closest('a');
        if (
            typeof targetA !== 'undefined' &&
            targetA !== null &&
            (targetA.getAttribute('href') === 'empty-link' || targetA.getAttribute('href') === '#empty-link')
        ) {
            e.preventDefault();
            e.stopPropagation();
        }
    });
};
